export class Login {
  usuario: string;
  senha: string;
}